export default function requestStatus(res) {
  if (res.Code === '999996') {
    localStorage.removeItem('user');
    this.$bus.$emit('showLogin');
  } else {
    this.$message.error(res.Message);
  }
}



// WEBPACK FOOTER //
// ./src/lib/requestStatus.js